import React from "react";
import { Helmet } from "react-helmet";
import DefaultHelmetMeta from "../../../components/DefaultHelmetMeta";

export const CollectionHelmet = props => {
  if (!props.collection) {
    return (
      <Helmet>
        <title>Casemasters - Collections</title>
        <DefaultHelmetMeta />
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{props.collection.name}</title>
      <meta
        name="description"
        content="View dental cases on casemasters, Largest online dental platform for dentists to showcase and discover great dental work."
      />
      <meta property="og:title" content={`${props.collection.name} | Casemasters`} />
      <meta property="og:description" content={`View ${props.collection.owner.name}'s collection on Casemasters`} />
      <meta property="og:image" content="https://casemasters.azureedge.net/public/fbpost-v-zXr4v4onaL.jpg" />
      <meta property="og:image:type" content="image/png" />
      <meta
        property="og:url"
        content={`https://www.casemasters.com/collections/${props.collection._id}/${props.collection.slug || ""}`}
      />
    </Helmet>
  );
};

export default CollectionHelmet;



// WEBPACK FOOTER //
// ./src/scenes/CollectionPage/components/CollectionHelmet.js